import React from "react";

function User03Icon({ fill, ...restProps }) {
  return (
    <svg
      width="24"
      height="24"
      fill={fill ?? ""}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M9.483 1.705a4.731 4.731 0 0 0-1.736.567C5.664 3.463 4.845 6.048 5.869 8.197a4.555 4.555 0 0 0 1.878 2.031 4.585 4.585 0 0 0 4.506 0c2.082-1.191 2.902-3.776 1.878-5.925a4.562 4.562 0 0 0-4.648-2.598M10.8 3.433c.795.227 1.526.86 1.871 1.622.318.701.318 1.69 0 2.392-.351.772-1.11 1.416-1.938 1.641-.342.094-1.164.085-1.516-.016a3.051 3.051 0 0 1-1.888-1.627c-.318-.7-.318-1.69 0-2.39a3.013 3.013 0 0 1 2.165-1.69c.278-.051 1.027-.012 1.306.068M9.4 12.52c-.924.079-1.439.161-2.083.329a11.451 11.451 0 0 0-4.348 2.241c-.488.409-1.075.99-1.17 1.156-.177.309-.163.624.039.906a.798.798 0 0 0 .662.33c.303-.001.411-.064.862-.507 1.529-1.502 3.33-2.414 5.394-2.732.507-.078 1.981-.078 2.488 0 2.11.325 3.879 1.234 5.474 2.811.362.359.487.427.782.428.27.001.51-.119.662-.33.202-.282.216-.597.039-.906-.16-.28-1.049-1.092-1.779-1.624a11.091 11.091 0 0 0-5.272-2.055c-.321-.037-1.502-.069-1.75-.047"
        fill-rule="evenodd"
        fill={fill ?? ""}
      />
    </svg>
  );
}

export default User03Icon;
